// Taxas MP (Pix/Cartão) e helpers de gross-up.
// Espelha o cálculo do wizard (NewChargeBatchWizard) — quando extraímos
// mais lugares que precisam do mesmo cálculo, esse é o source of truth.
// Se `methods.credit_card` está ativo, usa pior caso (cartão); senão Pix.

export const MP_FEE = {
  pix: { pct: 0.99, fixed: 0 },
  credit_card: { pct: 4.99, fixed: 0 },
};

export const feeOf = (methods) =>
  methods?.credit_card ? MP_FEE.credit_card : MP_FEE.pix;

// Fee estimada pra um valor cobrado
export const estimateFee = (amount, methods) => {
  const f = feeOf(methods);
  return (Number(amount) * f.pct) / 100 + f.fixed;
};

// Valor bruto pra dono receber `netAmount` líquido: (net + fixed) / (1 - pct/100).
// Usado quando dono marca "embutir taxa MP no valor cobrado".
export const grossUp = (netAmount, methods) => {
  const f = feeOf(methods);
  return (Number(netAmount) + f.fixed) / (1 - f.pct / 100);
};

// Arredonda pra 2 casas (centavos) — o que o MP aceita como amount.
export const round2 = (v) => Math.round(Number(v) * 100) / 100;
